__turbopack_context__.v({
  "accent": "pickup-point-picker-module-scss-module__TwID5a__accent",
  "actions": "pickup-point-picker-module-scss-module__TwID5a__actions",
  "body": "pickup-point-picker-module-scss-module__TwID5a__body",
  "caption": "pickup-point-picker-module-scss-module__TwID5a__caption",
  "city": "pickup-point-picker-module-scss-module__TwID5a__city",
  "close": "pickup-point-picker-module-scss-module__TwID5a__close",
  "dialog": "pickup-point-picker-module-scss-module__TwID5a__dialog",
  "eyebrow": "pickup-point-picker-module-scss-module__TwID5a__eyebrow",
  "filters": "pickup-point-picker-module-scss-module__TwID5a__filters",
  "foot": "pickup-point-picker-module-scss-module__TwID5a__foot",
  "head": "pickup-point-picker-module-scss-module__TwID5a__head",
  "label": "pickup-point-picker-module-scss-module__TwID5a__label",
  "layer": "pickup-point-picker-module-scss-module__TwID5a__layer",
  "list": "pickup-point-picker-module-scss-module__TwID5a__list",
  "map": "pickup-point-picker-module-scss-module__TwID5a__map",
  "pin": "pickup-point-picker-module-scss-module__TwID5a__pin",
  "point": "pickup-point-picker-module-scss-module__TwID5a__point",
  "radio": "pickup-point-picker-module-scss-module__TwID5a__radio",
  "segment": "pickup-point-picker-module-scss-module__TwID5a__segment",
  "segment-input": "pickup-point-picker-module-scss-module__TwID5a__segment-input",
  "segments": "pickup-point-picker-module-scss-module__TwID5a__segments",
  "selected": "pickup-point-picker-module-scss-module__TwID5a__selected",
  "switch": "pickup-point-picker-module-scss-module__TwID5a__switch",
  "title": "pickup-point-picker-module-scss-module__TwID5a__title",
  "titles": "pickup-point-picker-module-scss-module__TwID5a__titles",
  "zoom": "pickup-point-picker-module-scss-module__TwID5a__zoom",
});
